import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloudUploadAlt,
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { CSVReader } from "react-papaparse";
import { Link, Navigate, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import {
  bulkOnboardStudent,
  getBulkStudentDetails,
  bulkUploadnewApi
} from "../../actions/AmbassadorActions";
import BulkUploadedTable from "./BulkUploadedTable";
import { usePrompt } from '../common/usePrompt';

import CSVFileValidator from "csv-file-validator";
let requiredError = (headerName, rowNumber, columnNumber) => {
  return `<div class="red">${headerName} is required in the <strong>${rowNumber} row</strong> / <strong>${columnNumber} column</strong></div>`;
};
let validateError = (headerName, rowNumber, columnNumber) => {
  return `<div class="red">${headerName} is not valid in the <strong>${rowNumber} row</strong> / <strong>${columnNumber} column</strong></div>`;
};
let uniqueError = (headerName, rowNumber) => {
  return `<div class="red">${headerName} is not unique in the <strong>${rowNumber} row</strong> </div>`;
};
let isEmailValid = function (email) {
  let reqExp =
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
  return reqExp.test(email);
};

let isPhoneValid = function (phone) {
  let reqExp =/^\d+(\.\d{1,2})?$/;
  return reqExp.test(phone);
};
let isNameValid = function (name) {
  let reqExp = /^[a-zA-Z-.() ]+$/;
  return reqExp.test(name);
};

let isPasswordValid = function (password) {
  return password.length >= 4;
};

let CSVConfig = {
  headers: [
    {
      name: "Country",
      inputName: "country",
      required: true,
      requiredError,
    },
    {
      name: "Name",
      inputName: 'name',
      required: true,
      requiredError,
      validate : isNameValid,
      validateError
    },
    {
      name: "Email",
      inputName: "email",
      required: true,
      requiredError,
      validate: isEmailValid,
      validateError,
    },
    {
      name: "Phone",
      inputName: "phone",
      required: true,
      requiredError,
      validate : isPhoneValid,
      validateError,
    },
    {
      name: "City",
      inputName: "city",
      required: true,
      requiredError,
    },
    {
      name: "School",
      inputName: "school",
      required: true,
      requiredError,
    },
    {
      name: "Class",
      inputName: "class",
      required: true,
      requiredError,
    },
    {
      name: "Stream",
      inputName: "stream",
    },
    {
      name: "Paid",
      inputName: "paid",
      required: true,
      requiredError,
    },
  ],
};

const BulkOnBoardUpload = (props) => {
  // const detail = sessionStorage.getItem("ambDetail");
  const navigate = useNavigate();
  const detail = props.detail !== undefined && props.detail
  const [uploadedStudent, setUploadedStudent] = useState([]);
  let [csvData, setCsvData] = useState([]);
  const [showUplaodButton, setShowUploadButton] = useState(false);
  const [showErrorMsg, setshowErrorMsg] = useState(false);
  const [showFileSizeAlert,setShowFileSizeAlert] = useState(false)
  const [loading,setLoading] = useState(false)

  const [formIsDirty,setFormIsDirty] = useState(false);
  usePrompt( 'Are you sure you want to leave this page? You have unsaved changes. Do you want to leave?', formIsDirty );


  const handleOnDrop = async (data) => {
    let newData = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].errors.length == 0) {
        newData.push(data[i].data);
      }
    }
    if (newData.length > 0) {
      setUploadedStudent(newData);
    }
    function convert(obj) {
      const result = {};
      Object.keys(obj).forEach(function (key) {
        result[
          key
            .replace(/\s/g, "_")
            .replace(/#/g, "number")
            .replace(/[^0-9.-]+/g, "")
            .replace(/(#N\/A)/g, 0)
            .toLowerCase()
        ] = obj[key];
      });

      return result;
    }
    var result = newData.map(function (o) {
      return convert(o);
    });
    function convertIntObj(obj) {
      const res = {};
      for (const key in obj) {
        res[key] = {};
        for (const prop in obj[key]) {
          const parsed = parseInt(obj[key][prop], 10);
          res[key][prop] = isNaN(parsed) ? obj[key][prop] : parsed;
        }
      }
      return res;
    }
    var rest = convertIntObj(result);
    var arrayResult = Object.values(rest);
    const newArray = arrayResult.map((item) => {
      return {
        name: item.name,
        email: item.email,
        mobile_no: item.phone,
        country: item.country,
        city: item.city,
        class: item.class,
        school: item.school,
        is_free: item.paid,
      };
    });
    // console.log(newArray)
  };

  const handleOnError = (err, file, inputElem, reason) => {
    console.log(err);
  };

  const handleOnRemoveFile = (data) => {
    // console.log(data);
  };

  const handleChange = (e) => {
    let file = e.target.files[0];
    setShowFileSizeAlert(false)
    setFormIsDirty(true)
    // console.log('file size...',file)
    if(file.size < 1048576){
      CSVFileValidator(e.target.files[0], CSVConfig).then((csvData) => {
        csvData.inValidMessages !== undefined &&
          csvData.inValidMessages.forEach((message) => {
            {message && setshowErrorMsg(true) }
            document
              .getElementById("invalidMessages")
              .insertAdjacentHTML("beforeend", message);
          });

          
          {csvData.data.length !== undefined &&csvData.data.length>0 ? setShowUploadButton(true) : setShowUploadButton(false) }
          {csvData.inValidMessages !==undefined && csvData.inValidMessages.length > 0 && setShowUploadButton(false)}

        setCsvData(csvData.data);
      });
    }
    else{
      setShowFileSizeAlert(true)
    }
    

  };

  const registerBulkStudent = (e) => {
    e.preventDefault();
    setLoading(true)
  bulkUploadnewApi({ambassador_id:detail.id,list:csvData}).then((res) => {
    if(res.status){
      setFormIsDirty(false)
      swal(res.message && res.message, '', 'success')
      navigate('/ambassador/dashboard')
      setLoading(false) 
    }
    else {
      let msg = res.message ? res.message : 'Something went wrong'
      swal(msg, '', 'error')
      setLoading(false)
      setFormIsDirty(false)
  }
  })
  .catch(err => {
    console.log(err);
    setLoading(false)
  })
  // bulkOnboardStudent({ambassador_id:detail.id,list:csvData}).then((res) => {
  //   if(res.status){
  //     swal('Bulk Student Registered Successfully', '', 'success')
  //     navigate('/ambassador/dashboard')
  //   }
  //   else {
  //     let msg = res.message ? res.message : 'Something went wrong'
  //     swal(msg, '', 'error')
  // }
  // })
  // .catch(err => {
  //   console.log(err);
  // })

    
  };
  return (
    <>
      <div className="bulkUpload_wrapper w-75 mx-auto">
        <div className="title_contain">
          <h2>Choose a File to Upload</h2>
        </div>
        <div className="form-group">
          <input type="file" accept=".csv" className="w-50  mx-auto form-control" id="file" onChange={handleChange} />
        </div>
        {showErrorMsg &&  <div id="invalidMessages" className="invalid_msges"></div>}

        {showFileSizeAlert && <h6 className="text-danger mt-3">Please keep the file size below 1 MB.</h6>}
       
        <div className="bulk_onBoardUpload_wrap">
          {/* <label htmlFor='bulkOnBoard'>
                    <input type="file" onChange={handleFileChange}  id='bulkOnBoard'/>
                    <FontAwesomeIcon icon={faCloudUploadAlt} />
                    <h4>Select file to Upload</h4>
                    <button  onClick={handleParse} id='bulkOnBoard'>Upload File</button>
                </label> */}

          {/* <CSVReader
                    onDrop={handleOnDrop}
                    onError={handleOnError}
                    addRemoveButton
                    config={{
                    header: true
                    }
                    
                  }
                    onRemoveFile={handleOnRemoveFile}
                >
                    <span>Drop CSV file here or click to upload.</span>
                </CSVReader> */}
        </div>
      </div>
      <div className="bulk_uploadedData_table">
        <BulkUploadedTable studentData={csvData !== undefined && csvData} />
        {/* <div id='invalidMessages'></div> */}
      </div>

      <div className="uploaded_files_res_result mt-3">
        <div className="container">
          {/* <div className='row'>
              <div className='col-md-6 d-flex align-items-center mb-3'>
                <h4 className='text-success'><FontAwesomeIcon className='me-2' icon={faCheckCircle}/> 0 Students data ready to upload!</h4>
              </div>
              <div className='w-100'></div>
              <div className='col-md-6 d-flex  align-items-center '>
                <h4 className='text-danger'><FontAwesomeIcon className='me-2' icon={faTimesCircle}/> 0 Students data causing error!</h4>
              </div>
            </div> */}
          {showUplaodButton && (
            <div className="row">
              <div className="col-lg-12">
                {loading ?
                (<button type="submit" disabled className="btn btn-primary w-25 btn-lg auth_btn">
                <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                Uploading ...</button>) 
                :<button
                  className="btn btn-primary mt-4"
                  onClick={registerBulkStudent}
                >
                  Register In Bulk
                </button>
                }
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BulkOnBoardUpload;
